<template>
    <li :class="['alert',  'alert-' + alert.type]"
        :id="alert.id"
        role="alert"
        @click="click">
       <span @click="click">
          <strong>
              {{alert.title}}
          </strong>
              {{alert.body}}
       </span>
    </li>
</template>

<script type="text/babel">
import { mapMutations } from 'vuex';

export default {
    props: {
        closeTime: {
            type: Number,
            default: 15000
        },
        alert: {
            required: true
        }
    },
    methods: {
        ...mapMutations(['removeAlert']),
        click(e){
            this.removeAlert(this.alert);
            this.$emit('click', e)
        }
    },
    mounted () {
        setTimeout(() => {
            this.removeAlert(this.alert);
        }, this.closeTime);
    }
};

</script>

<style scoped>
    .alert {
        list-style-type: none;
    }
</style>
